<template>
  <div class="description-box">
    <div class="icon"></div>
    <div class="description-text">
      <h2>{{ title }}</h2>
      <template v-for="(item, index) in content" :key="index">
        <p>{{ item }}</p>
      </template>
      <el-button type="primary" @click="handleClick" v-if="showbtn">{{ btnText }}</el-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { DescriptionTextProps } from './description.ts'

const props = withDefaults(defineProps<DescriptionTextProps>(), {
  btnText: '了解详情'
})

const emit = defineEmits<{
  (e: 'detail'): void
}>()
const handleClick = () => {
  emit('detail')
}
</script>

<style lang="scss" scoped>
.description-box {
  width: 553px;
  display: flex;
  justify-content: space-between;
  .icon {
    flex-shrink: 0;
    width: 35px;
    height: 35px;
    background: url('~@/assets/img/standard/description-icon.png') no-repeat center/100% 100%;
    margin-right: 16px;
  }
  .description-text {
    h2 {
      padding: 5px 0 8px;
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      color: #16181A;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 22px;
      color: #64666B;
    }
    ::v-deep(.el-button) {
      width: 188px;
      height: 40px;
      background-color: #3461FF;
      border-radius: 4px;
      border-color: #3461FF;
    }
  }
}
</style>
